import * as SwitchPrimitives from '@radix-ui/react-switch';
import { clsx } from 'clsx';
import * as React from 'react';

import styles from './switch.module.scss';

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>;

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={clsx(styles.switch, className)}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb className={styles.switch__thumb} />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
export type { SwitchProps };
